import { Reducer } from 'redux';
import {
  DOWNLOAD_LEARNER_MATCHING_METRICS,
  DOWNLOAD_LEARNER_MATCHING_METRICS_FAILURE,
  DOWNLOAD_LEARNER_MATCHING_METRICS_SUCCESS,
  GET_LEARNER_MATCHING_METRICS,
  GET_LEARNER_MATCHING_METRICS_FAILURE,
  GET_LEARNER_MATCHING_METRICS_SUCCESS,
  LearnerMatchingMetricsActionTypes,
  LearnerMatchingMetricsState,
} from './types';

const initialState: LearnerMatchingMetricsState = {
  isLoading: false,
  isDownloading: false,
  data: null,
  error: null,
};

const learnerMatchingMetricsReducer: Reducer<LearnerMatchingMetricsState, LearnerMatchingMetricsActionTypes> = (
  state = initialState,
  action: LearnerMatchingMetricsActionTypes,
): LearnerMatchingMetricsState => {
  switch (action.type) {
    case GET_LEARNER_MATCHING_METRICS:
      return { ...state, isLoading: true, error: null };
    case GET_LEARNER_MATCHING_METRICS_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case GET_LEARNER_MATCHING_METRICS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case DOWNLOAD_LEARNER_MATCHING_METRICS:
      return { ...state, isDownloading: true };
    case DOWNLOAD_LEARNER_MATCHING_METRICS_SUCCESS:
      return { ...state, isDownloading: false };
    case DOWNLOAD_LEARNER_MATCHING_METRICS_FAILURE:
      return { ...state, isDownloading: false, error: action.payload };
    default:
      return state;
  }
};

export default learnerMatchingMetricsReducer;
